import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';
import type { IRecruiterOption } from '../MyPerformance.redux';

export const placementRecruiterFilterName = 'placementRecruiter';

export interface IMyPerformanceFilter {
  placementRecruiter: IRecruiterOption | null;
}

export const defaultValues: IMyPerformanceFilter = {
  placementRecruiter: null,
};

export const getPlacementRecruiterFilterSpec = (recruiterOptions: IRecruiterOption[]) => [
  {
    filterName: 'Placement Recruiter',
    name: placementRecruiterFilterName,
    type: FilterCompTypes.TYPEAHEADDROPDOWN,
    isMultiSelect: false,
    options: recruiterOptions,
    fallbackPlacements: ['top-start', 'bottom-start', 'right'],
    applyOnClickAway: true,
  },
];
